var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "phone",
    d: "M3.208,6.917a13.071,13.071,0,0,0,5.875,5.875l1.958-1.958a.764.764,0,0,1,.917-.208,9.948,9.948,0,0,0,3.167.5.869.869,0,0,1,.6.25A.816.816,0,0,1,16,12v3.125a.929.929,0,0,1-.875.875,14.872,14.872,0,0,1-7.6-2.021,14.926,14.926,0,0,1-5.5-5.5A14.872,14.872,0,0,1,0,.875a.836.836,0,0,1,.271-.6A.838.838,0,0,1,.875,0H4a.815.815,0,0,1,.625.271.871.871,0,0,1,.25.6,9.948,9.948,0,0,0,.5,3.167.852.852,0,0,1-.208.917Z",
    fill: "#0267c1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d04e3cf3f3b7732a811127aba2c51636.svg";
export { ForwardRef as ReactComponent };